/**
 * analyzeNavigation.ts
 *
 * URL helpers for moving between Analyze and Extract (Requirement 9.4).
 *
 * "Open field in Extract" sets `mode=extract&loan=…&doc=…&field=…` through
 * `writeWorkspaceParams` and adds `from=analyze`, so Extract can offer a way
 * back. Going back sets `mode=analyze`, drops `from` and keeps the selection,
 * so Analyze still highlights the finding the user came from.
 */

import { writeWorkspaceParams } from '../urlState';
import type { FieldRef } from './analyzeModel';

/** Query param that records where the user came from. Not a selection key. */
export const ORIGIN_PARAM = 'from';
export const ANALYZE_ORIGIN = 'analyze';

type SearchInput = URLSearchParams | string | null | undefined;

export function buildOpenFieldParams(search: SearchInput, ref: FieldRef): URLSearchParams {
  const next = writeWorkspaceParams(search, {
    mode: 'extract',
    loan: ref.loanId,
    doc: ref.documentId,
    field: ref.fieldId,
    exception: null,
  });
  next.set(ORIGIN_PARAM, ANALYZE_ORIGIN);
  return next;
}

export function buildBackToAnalyzeParams(search: SearchInput): URLSearchParams {
  const next = writeWorkspaceParams(search, { mode: 'analyze' });
  next.delete(ORIGIN_PARAM);
  return next;
}

export function cameFromAnalyze(search: SearchInput): boolean {
  const params = search instanceof URLSearchParams ? search : new URLSearchParams(search ?? '');
  return params.get(ORIGIN_PARAM) === ANALYZE_ORIGIN;
}
